// raw data is returned from Legion API

export let TeamState = /*#__PURE__*/function (TeamState) {
  TeamState["ACTIVE"] = "ACTIVE";
  TeamState["DISBANDED"] = "DISBANDED";
  TeamState["PURGED"] = "PURGED";
  return TeamState;
}({});
export let TeamMembershipSettings = /*#__PURE__*/function (TeamMembershipSettings) {
  TeamMembershipSettings["OPEN"] = "OPEN";
  TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
  return TeamMembershipSettings;
}({});
export let TeamDiscoverability = /*#__PURE__*/function (TeamDiscoverability) {
  TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
  return TeamDiscoverability;
}({});
export let TeamRestriction = /*#__PURE__*/function (TeamRestriction) {
  TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
  TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
  return TeamRestriction;
}({});
export let TeamPermission = /*#__PURE__*/function (TeamPermission) {
  TeamPermission["FULL_WRITE"] = "FULL_WRITE";
  TeamPermission["FULL_READ"] = "FULL_READ";
  TeamPermission["NONE"] = "NONE";
  return TeamPermission;
}({}); // Note: Should never see this, as UI should get a 404 instead. Included for completeness.

// a data returned by creating a new team endpoint

// a data returned by inviting team member